import { render, staticRenderFns } from "./c-template-selector.vue?vue&type=template&id=279ba790"
import script from "./c-template-selector.vue?vue&type=script&lang=js"
export * from "./c-template-selector.vue?vue&type=script&lang=js"
import style0 from "./c-template-selector.vue?vue&type=style&index=0&id=279ba790&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports